import { Injectable } from '@angular/core';
import { FornecedorEstrutura } from '../models/fornecedor-estrutura';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';

import { Observable } from 'rxjs';
import { VariavelSimulacao } from '../models/variavel-simulacao';
import { SimulacaoEstrutura } from '../models/simulacao-estrutura';
import { InfoRegraFormula } from '../models/info-regra-formula';
import { ClonarEstrutura } from '../models/clonar-estrutura';

@Injectable({
  providedIn: 'root'
})
export class FornecedorEstruturaService {

  constructor(
    private http: HttpClient
  ) { }

  salvar(forn: FornecedorEstrutura) {
    return this.http.post(globals.apiUrl + '/api/FornecedorEstrutura/Salvar', forn);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/FornecedorEstrutura/Excluir', {
      params: new HttpParams().set('id', id),
    });
  }

  consultarPorId(id) {
    let parametros = new HttpParams().set('id', id);

    return this.http.get<any>(globals.apiUrl + '/api/FornecedorEstrutura/Buscar', {
      params: parametros,
    });
  }

  consultarImagemPorId(id) {
    return this.http.get(globals.apiUrl + '/api/FornecedorEstrutura/BuscarImagem',
      { params: new HttpParams().set('id', id), responseType: 'blob' });
  }

  consultarFornecedores() {
    return this.http.get<FornecedorEstrutura[]>(globals.apiUrl + '/api/FornecedorEstrutura/Lista');
  }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    descri,
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('descri', descri ? descri : '');

    return this.http.get<any>(globals.apiUrl + '/api/FornecedorEstrutura/ListaPag', {
      params: parametros,
    });
  }

  consultarVariaveis(formulaGeral) {
    return this.http.get<any>(globals.apiUrl + '/api/FornecedorEstrutura/BuscarVariaveis',
      { params: new HttpParams().set('formulaGeral', formulaGeral) });
  }

  consultarVariaveisParaSimular(idFornecedor?, telhado?, orientacao?): Observable<VariavelSimulacao[]> {
    let parametros = new HttpParams()
      .set('idFornecedor', idFornecedor)
      .set('telhado', telhado)
      .set('orientacao', orientacao);

    return this.http.get<VariavelSimulacao[]>(globals.apiUrl + '/api/FornecedorEstrutura/BuscarVariaveisParaSimular', {
      params: parametros,
    });
  }

  simularEstrutura(simulacaoEstrutura: SimulacaoEstrutura) {
    return this.http.post(globals.apiUrl + '/api/FornecedorEstrutura/Simular', simulacaoEstrutura);
  }

  consultarInfoRegras() {
    return this.http.get<InfoRegraFormula>(globals.apiUrl + '/api/FornecedorEstrutura/BuscarInfoRegras');
  }

  clonar(clonarEstrutura: ClonarEstrutura) {
    return this.http.post(globals.apiUrl + '/api/FornecedorEstrutura/Clonar', clonarEstrutura);
  }
}
